import React from 'react'
import * as c from 'classnames'
import {Link} from 'gatsby'
import {childLink, childText, activeStyle} from '../styles/nav.module.css'


export default function NavMenuChildItem({label, navKey, route, active}) {

  return (
    <Link to={route} className={childLink}>
      <div className={c(childText, {[activeStyle]: active})}>
        {label}
      </div>
    </Link>
  )
}
